import { useUserMe } from 'api/goodtrust/user'
import { formatName } from 'utils/format'
import { ApiType } from 'utils/types'

export type Contact = ApiType['TrustedContactResponse']

export interface ActualContact extends Contact {
  avatar?: ApiType['FileResponse'] | null
  first_name?: string | null
  last_name?: string | null
  full_name?: string | null
  email?: string | null
  sharedItemCount?: number
}

export const getSharedItemsCount = (contact?: ApiType['TrustedContactResponse']) => {
  return (
    (contact?.orders?.length ?? 0) +
    (contact?.documents?.length ?? 0) +
    (contact?.devices?.length ?? 0) +
    (contact?.sites?.length ?? 0) +
    (contact?.directives?.length ?? 0)
  )
}

export const getSuggestedItemCount = (
  suggestions?: ApiType['TrustedContactSuggestionsResponse']
) => {
  return (
    (suggestions?.orders?.length ?? 0) +
    (suggestions?.documents?.length ?? 0) +
    (suggestions?.devices?.length ?? 0) +
    (suggestions?.sites?.length ?? 0) +
    (suggestions?.directives?.length ?? 0)
  )
}

export const useActualContact = (contact?: ApiType['TrustedContactResponse']) => {
  const { data: user, error: userError } = useUserMe()
  const userUuid = user?.json?.uuid
  const isUserLoaded = userUuid != null
  const isUserLoading = user == null && userError == null
  const showContactUser = Boolean(isUserLoaded && userUuid === contact?.user?.uuid)
  const actualContact: ActualContact | undefined =
    contact && isUserLoaded
      ? {
          ...(showContactUser ? contact.contact_user : contact.user),
          ...contact,
          uuid: contact.uuid,
          full_name: showContactUser
            ? formatName(contact.contact_user?.first_name, contact.contact_user?.last_name)
            : formatName(contact.user?.first_name, contact.user?.last_name),
          sharedItemCount: getSharedItemsCount(contact),
        }
      : undefined
  return { actualContact, showContactUser, isUserLoading }
}

export const useActualContacts = (contacts?: ApiType['TrustedContactResponse'][]) => {
  const { data: user } = useUserMe()
  const userUuid = user?.json?.uuid
  const isUserLoaded = userUuid != null
  const actualContacts: ActualContact[] | undefined = isUserLoaded
    ? contacts?.map((c) => {
        const showContactUser = Boolean(userUuid === c?.user?.uuid)
        return {
          ...(showContactUser ? c.contact_user : c.user),
          ...c,
          uuid: c.uuid,
          full_name: showContactUser
            ? formatName(c.contact_user?.first_name, c.contact_user?.last_name)
            : formatName(c.user?.first_name, c.user?.last_name),
          sharedItemCount: getSharedItemsCount(c),
        }
      })
    : undefined
  return actualContacts
}
